import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { UmsService } from '../ums.service';
import { ModalpopService } from '../modalpop.service';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-debar-exam-limit',
  templateUrl: './debar-exam-limit.component.html',
  styleUrls: ['./debar-exam-limit.component.scss']
})
export class DebarExamLimitComponent implements OnInit {
debarMarksForm : FormGroup;
  ListOfMarks: any;
  filteredListOfMarks: any;
  SessionNo: any;
  constructor(
    public umsService: UmsService,
    private modalPopupService: ModalpopService,
    private fb: FormBuilder,   public router: Router,  private httpClient: HttpClient,
    private spinner:NgxSpinnerService
    ) { }

  ngOnInit(): void {
    if(JSON.parse(sessionStorage.getItem("session")) == null){
      this.fetchSecretData();
    }
    else if(JSON.parse(sessionStorage.getItem("session")) != null){
      let sessionData = JSON.parse(sessionStorage.getItem("session"));
      this.SessionNo = sessionData.SnNo
    }
    this.debarMarksForm = this.fb.group({
      list: new FormControl(),
      list2: new FormControl(),
      list3: new FormControl(),
      Colg: new FormControl(),
      Debar: new FormControl(),
      Chng: new FormControl(),
    })
    this.fetchList();
  }

  fetchSecretData() {
    this.umsService.getSecretData().subscribe((res) => {
      this.SessionNo = res.projectPharam['SnNo']
      }
    );
  }

  fetchList(){
    let payload = {}
    payload ["SnNo"] = this.SessionNo;
    payload["InCode"] = 7;
    payload["OpId"] = sessionStorage.getItem('userId');
    this.umsService.fetchRegiList(payload).subscribe((res) => {
    if (res.status) {
      this.ListOfMarks = res.data;
      this.filteredListOfMarks = this.ListOfMarks.slice();
    }
    else {
    
    }
    
    });
    
      }
}
